import React, { useEffect, useState } from "react";
import { FaEdit } from "react-icons/fa";
import { format } from "date-fns";
import { useOrderDetails } from "../../contexts/orderDetails";
import OrderDetailsEditLabelProp from "../modals/OrderDetailsEditLabelProp";
import { OrderName } from "../../enums";
import { basePathForStorage } from "../config";
import EditOrderPreference from "./EditOrderPreference";
import { useAuth } from "../../contexts/auth";
import { IoMdAddCircle } from "react-icons/io";

const LabelPropertyPaper = (orderDetails) => {
  return (
    <>
      <div>
        <p className="text-navy-blue font-semibold">Paper size </p>
        <p>{orderDetails.paper_size}</p>
      </div>

      <div>
        <p className="text-navy-blue font-semibold capitalize">
          {orderDetails.mtr_daya}
        </p>
        <p>{orderDetails.daya_mtr}</p>
      </div>

      <div>
        <p className="text-navy-blue font-semibold">Core</p>
        <p>{orderDetails.core}</p>
      </div>

      <div>
        <p className="text-navy-blue font-semibold">Paper-type</p>
        <p>{orderDetails.paper_type}</p>
      </div>

      {/* <div>
        <p className="text-navy-blue font-semibold">Paper-color</p>
        <p>{orderDetails.paper_color}</p>
      </div> */}

      <div>
        <p className="text-navy-blue font-semibold">Rolls</p>
        <p>{`${orderDetails.ready_roll || 0}/${orderDetails.roll} Ready`}</p>
      </div>
    </>
  );
};

const LabelPropertyBarcodeColor = (orderDetails) => {
  return (
    <>
      <div>
        <p className="text-navy-blue font-semibold">Label Size </p>
        <p>{orderDetails.size}</p>
      </div>

      <div>
        <p className="text-navy-blue font-semibold">Labels</p>
        <p>{orderDetails.label}</p>
      </div>

      <div>
        <p className="text-navy-blue font-semibold">Core</p>
        <p>{orderDetails.core}</p>
      </div>

      <div>
        <p className="text-navy-blue font-semibold">Ups</p>
        <p>{orderDetails.ups}</p>
      </div>

      <div>
        <p className="text-navy-blue font-semibold">Paper-type</p>
        <p>{orderDetails.paper_type}</p>
      </div>

      <div>
        <p className="text-navy-blue font-semibold">Rolls</p>
        <p>{`${orderDetails.ready_roll || 0}/${orderDetails.roll} Ready`}</p>
      </div>
    </>
  );
};

export default function SectionOrderDetails({
  setLabelPropToEdit,
  labelPropToEdit,
}) {
  const [{ orderDetails }, { setPaperSizeFormOpen }] = useOrderDetails();

  const [{ activeUser, isEditor }] = useAuth();
  const [editableFields, setEditableFields] = useState({
    gap: orderDetails.order_status > 0 && isEditor,
    teeth: orderDetails.order_status > 0 && isEditor,
    paper_size: orderDetails.order_status > 0 && isEditor,
  });

  useEffect(() => {
    setEditableFields({
      gap: orderDetails.order_status > 0 && isEditor,
      teeth: orderDetails.order_status > 0 && isEditor,
      paper_size: orderDetails.order_status > 0 && isEditor,
    });
  }, [orderDetails.order_status]);

  const [prefToEdit, setPrefToEdit] = useState(null);

  return (
    <div className="col-span-8 border border-gray-400 rounded-md p-4">
      <EditOrderPreference
        prefToEdit={prefToEdit}
        setPrefToEdit={setPrefToEdit}
      />

      <div className="flex justify-between">
        <p>
          Order place on{" "}
          {format(new Date(orderDetails.created_at), "dd/MM/yyyy")}
        </p>

        <p>Order by {orderDetails.party_name}</p>
      </div>

      <div className="mb-5">
        <div className="flex justify-center gap-4 items-center mb-4">
          <p className="text-center text-orange text-2xl ">Label Property </p>
          {isEditor && (
            <button
              className="p-1 rounded-md my-1 bg-navy-blue text-white"
              onClick={() => {
                setLabelPropToEdit({ type: orderDetails.order_type });
              }}
            >
              <FaEdit />
            </button>
          )}
        </div>
        <div className="flex w-full justify-between text-center">
          <OrderDetailsEditLabelProp
            labelPropToEdit={labelPropToEdit}
            setLabelPropToEdit={setLabelPropToEdit}
          />
          {OrderName[orderDetails.order_type] === "Paper" ? (
            <LabelPropertyPaper {...orderDetails} />
          ) : (
            <LabelPropertyBarcodeColor {...orderDetails} />
          )}
        </div>
      </div>

      <div>
        <p className="text-center text-orange text-2xl mb-4">
          Order Special Detail
        </p>
        <div>
          <table className="text-left order-details-table">
            <tbody>
              <tr>
                <th>Order type</th>
                <td>:</td>
                <td>{OrderName[orderDetails.order_type]}</td>
              </tr>
              <tr>
                <th>Brand Name </th>
                <td>:</td>
                <td>{orderDetails.brand_name}</td>
              </tr>
              <tr>
                <th>Note </th>
                <td>:</td>
                <td>{orderDetails.note}</td>
              </tr>
              <tr>
                <th>Photo</th>
                <td>:</td>
                <td>
                  {orderDetails.photo && (
                    <a
                      className="max-w-[200px] block"
                      href={basePathForStorage + orderDetails.photo}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <img
                        src={basePathForStorage + orderDetails.photo}
                        alt="color order"
                      />
                    </a>
                  )}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      {/* pref */}
      {OrderName[orderDetails.order_type] !== "Paper" && (
        <div>
          <p className="text-center text-orange text-2xl mb-4">Preferences</p>
          <div className="flex justify-between text-center">
            <div>
              <div className="flex gap-2 items-center">
                <p className="text-navy-blue font-semibold">Gap</p>
                {editableFields?.gap && (
                  <button
                    className="p-1 rounded-md my-1 bg-navy-blue text-white"
                    onClick={() => {
                      setPrefToEdit({ type: "gap" });
                    }}
                  >
                    <FaEdit />
                  </button>
                )}
              </div>
              <p>{orderDetails.gap}</p>
            </div>

            <div>
              <div className="flex gap-2 items-center">
                <p className="text-navy-blue font-semibold">Cut</p>
                {editableFields?.cut && (
                  <button className="p-1 rounded-md my-1 bg-navy-blue text-white">
                    <FaEdit />
                  </button>
                )}
              </div>
              <p>{orderDetails.cut}</p>
            </div>

            <div>
              <div className="flex gap-2 items-center">
                <p className="text-navy-blue font-semibold">Teeth</p>
                {editableFields?.teeth && (
                  <button
                    className="p-1 rounded-md my-1 bg-navy-blue text-white"
                    onClick={() => {
                      setPrefToEdit({ type: "teeth" });
                    }}
                  >
                    <FaEdit />
                  </button>
                )}
              </div>
              <p>{orderDetails.teeth}</p>
            </div>

            <div>
              <div className="flex gap-2 items-center">
                <p className="text-navy-blue font-semibold">Type</p>
                {editableFields?.type && (
                  <button className="p-1 rounded-md my-1 bg-navy-blue text-white">
                    <FaEdit />
                  </button>
                )}
              </div>
              <p>{orderDetails.type}</p>
            </div>

            <div>
              <div className="flex gap-2 items-center">
                <p className="text-navy-blue font-semibold">Paper Size</p>
                {editableFields?.paper_size && (
                  <>
                    <button
                      className="p-1 rounded-md my-1 bg-navy-blue text-white"
                      onClick={() => {
                        setPrefToEdit({ type: "paper_size" });
                      }}
                    >
                      <FaEdit />
                    </button>
                  </>
                )}
              </div>
              <p>{orderDetails.paper_size}</p>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
